import React, { Component } from 'react'
import { Grid, Button, Modal, Icon, Loader, GridRow, GridColumn, Radio } from 'semantic-ui-react'
import { createArticleSetFromExistingLineItem } from '../../../apiCalls/jobTransitionCalls'
class createArticleSet extends Component {
    constructor(props) {
        super(props)
        this.state = {
            articleHeaderX: "",
            articleHeaderV: [],
            htsus: "",
            loading: false,
            articleSetType: 1
        }
    }
    setArticleSet(value, merchandiseId, htsus) {
        let artV = this.state.articleHeaderV.slice();
        if(value === 'X'){
            if(artV.indexOf(merchandiseId)>0){ 
                let newArtV = artV.filter((item)=>{
                    return item !== merchandiseId
                }); 
                this.setState({"articleHeaderV": newArtV});
            }
            this.setState({"articleHeaderX": merchandiseId})
            this.setState({"htsus": htsus})
        }
        if(value === 'V'){
            if(this.state.articleHeaderX ===  merchandiseId){
                this.setState({"articleHeaderX": ""})
            }
            if(artV.indexOf(merchandiseId) === -1){ 
                artV.push(merchandiseId); 
                this.setState({"articleHeaderV": artV});
            }
        }
        if(value === ''){
            if(artV.includes(merchandiseId)){
                var filtered = artV.filter((item)=>{
                    return item !== merchandiseId
                })
                this.setState({"articleHeaderV": filtered}) 
            }
            if(this.state.articleHeaderX === merchandiseId) {
                this.setState({"articleHeaderX":""})
                this.setState({"htsus": ""})
            }
        }
    }
    handleConfirm(){
        if(this.state.articleSetType === 1){
            this.props.createNewArticleSet();
            setTimeout(()=>{
                this.props.refreshESFrom();
            },100);
        }else{
            createArticleSetFromExistingLineItem(this.props.shipId, this.props.invoiceId, this.state, this.props.refreshESFrom)
        }
    }

    render() {
        const { trigger, handleClose, updateModelOpen, lineItems, invoiceindex, invoiceId } = this.props
        const normalLineItems = lineItems.filter((item)=>{
            return !item.articleHeader
        })
       return (
        <Modal
            style={{"top":"10px"}}
            id='createArticleSetModal'
            trigger={trigger}
            open={updateModelOpen}
            // open={true}
            onClose={handleClose}
      >
        <Modal.Header>
          <Icon name="warning sign" color="blue" />
          {`Create Article set from the following line items in Invoice ${invoiceindex} for shipment - "${this.props.shipId}". This
          action cannot be undone.`}
        </Modal.Header>
        <Modal.Content scrolling style={{"width":"100%"}}>
          <Modal.Description>
            <div style={{"marginBottom":"10px"}}>   
            <Radio
                id={"articleSetType_1"}
                label={"New Article Set"}
                name={"articleSetType"}
                value={1}
                checked={this.state.articleSetType === 1}
                onClick={value => {
                this.setState({"articleSetType":1})
                }}
            />
            <Radio
                id={"articleSetType_2"}
                label={"Create Article Set from existing line items"}
                name={"articleSetType"}
                value={2}
                style={{"paddingLeft":"20px"}}
                checked={this.state.articleSetType === 2}
                onClick={value => {
                this.setState({"articleSetType":2})
                }}
            /></div>
        { 
        this.state.articleSetType === 2 && 
        <Grid style={{"height":"80%", "overflow":"scroll", "border":"1px solid #ccc"}}>
            <GridRow style={{"backgroundColor":"#efefef"}}>
               <GridColumn width={3}><b>Article Set Type</b></GridColumn><GridColumn width={1}></GridColumn><GridColumn width={8}><b>Line Items</b></GridColumn>
           </GridRow> 
           {
               normalLineItems.length ? normalLineItems.map((item, index)=>{
                   if(!item.articleHeader){
                        return (
                            <GridRow Column={3} style={{"padding":"5px", "backgroundColor":((index+1)%2===0) ?"#efefef":"", "paddingLeft":this.state.articleHeaderV.includes(item.merchandiseId)?"25px":""}} >
                                <GridColumn width={3}>
                                    <select id='articleType' onChange={(e)=>{
                                        this.setArticleSet(e.target.value, item.merchandiseId, item.merchandiseDuties[0].htsus)
                                    }}>
                                        <option value=''>None</option>
                                        { (item.merchandiseId === this.state.articleHeaderX || this.state.articleHeaderX==='') && <option value='X'>Article Header X</option> }
                                        <option value='V'>Article Header V</option>
                                    </select>
                                </GridColumn>
                                <GridColumn width={1}></GridColumn>
                                <GridColumn width={8}>
                                    {
                                        (item.merchandiseDuties[0].htsus ? item.merchandiseDuties[0].htsus + " | " : "HTS# | ") + (item['commercialDescription']? item['commercialDescription']+" | ":"") + item.merchandiseDuties[0].enteredValue
                                    }
                                </GridColumn>
                            </GridRow>
                        ) 
                }
                }): <div style={{"paddingTop":"30px"}}>No Line Items found.</div>
           }
                
        </Grid>
        }
        </Modal.Description></Modal.Content>
        <Modal.Actions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={this.handleConfirm.bind(this)}
            color="blue"
            loading={this.state.loading}
            disabled={this.state.loading || (this.state.articleSetType === 2 && !(this.state.articleHeaderX && this.state.articleHeaderV.length > 0)) }
          >
            Confirm
          </Button>
        </Modal.Actions>
        </Modal>
        )
    }
}

export default createArticleSet;